/* Copyright (c) 2018 Backpack Health LLC */

import React from 'react';

import AppNavTitleRow from '../components/appNav/AppNavTitleRow';
import AppNavStep from '../components/appNav/AppNavStep';
import IconNotice from '../components/icons/IconNotice';

import ContentError from '../contentViews/ContentError';
import { ScrollAwareFixedHeader } from '../components/ScrollAware';


interface Props {
  goBack(): void;
}

class NotFound extends React.Component<Props, {}> {
  render() {
    return (
      <div>
        <ScrollAwareFixedHeader colorThemeName="profile">
          <AppNavStep
            goBack={this.props.goBack}
            color="white"
          />

          <AppNavTitleRow phraseData={{ id: 'unexpected-error.container.headline' }} />
        </ScrollAwareFixedHeader>

        <div>
          <ContentError
            mainImage={<IconNotice color="neutral" size="200" />}
            explanation="error.api.404-not-found.message"
            textClassName="font-body"
          />
        </div>
      </div>
    );
  }
}

export default NotFound;
